import { render, staticRenderFns } from "./MainPollCard.vue?vue&type=template&id=7f7a1fb8&scoped=true&"
import script from "./MainPollCard.vue?vue&type=script&lang=js&"
export * from "./MainPollCard.vue?vue&type=script&lang=js&"
import style0 from "./MainPollCard.vue?vue&type=style&index=0&id=7f7a1fb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7a1fb8",
  null
  
)

export default component.exports